import React from 'react';


export default ( { match } ) => {
    console.log(match);
    return (
        <div>Cannot find the request page.</div>
    );
};